import { OreNavBarWrapper } from '@edenredespana/oreneta'
import { Navbar } from '@/Account/ui/organisms'

const AccountWrapper = ({
  children,
}: {
  children: React.ReactNode
  hasLanguages?: boolean
}): JSX.Element => {
  return (
    <div style={{ display: 'flex' }}>
      <Navbar />
      <OreNavBarWrapper>{children}</OreNavBarWrapper>
    </div>
  )
}

export { AccountWrapper }
